import React from 'react';
import { Stack, Typography } from '@mui/material';

interface InfoRowProps {
  label: string;
  value?: React.ReactNode;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.5 }}>
    <Typography variant="body2" sx={{ opacity: 0.8 }}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600} textAlign="right" ml={2}>
      {value ?? '—'}
    </Typography>
  </Stack>
);

export default InfoRow;
